import jwtDecode from 'jwt-decode';

export const decodeAuthToken = token => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);

    if (!decoded || typeof decoded !== 'object' || Array.isArray(decoded)) {
      return null;
    }

    if (decoded.exp && decoded.exp * 1000 <= Date.now()) {
      return null;
    }

    return decoded;
  } catch (error) {
    return null;
  }
};
